import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import DescriptionIcon from '@mui/icons-material/Description';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import AppDocuServiceCall from '../_Utils/AppDocuServiceCall';
import { notifySomething } from '../_Utils/AppDocuCommon';
import EditServiceActivityDialog from '../ServiceActivity_Components/EditServiceActivityDialog';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { serviceProvisionOptions } from '../ServiceActivity_Components/_Options';
import { isQuillEmpty } from '../../../utils/quill';

class ActionsFormatter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      dialogTitle: '',
      dialogContent: '',
    };
  }

  deleteService = async (id) => {
    if (!window.confirm('Delete this item?')) return;
    try {
      const res = await AppDocuServiceCall.deleteServiceActivity(id);
      if (res.data && res.data.is_valid === false) {
        notifySomething(res.data.message || 'Error deleting item', 'error');
        return;
      }
      await this.props.onItemsChange(); // Refresh the list after deletion !!!
    } catch (error) {
      console.error('Error deleting item:', error);
      notifySomething('Error deleting item', 'error');
    }
  };
  
  handleOpenDownloadDialog = (title, content) => {
    this.setState({ dialogOpen: true, dialogTitle: title, dialogContent: content });
  };

  handleCloseDialog = () => {
    this.setState({ dialogOpen: false, dialogTitle: '', dialogContent: '' });
  };

  render() {
    const { row, onOpenEditDialog } = this.props;
    const { dialogOpen } = this.state;
    const hasDesc = !isQuillEmpty(row.service_desc);
    const hasSolution = !isQuillEmpty(row.service_solution);    
    let iconColor = '#bbb';
    if (hasSolution) iconColor = '#43a047'; // verde
    else if (hasDesc) iconColor = '#ff9800'; // arancione
    const iconDisabled = !hasDesc && !hasSolution;
    const provisionOpt = serviceProvisionOptions.find(opt => opt.name === row.service_provision);
    let provisionIconObj = null;
    if (provisionOpt && provisionOpt.icon) {
      const IconComp = provisionOpt.icon;
      provisionIconObj = {
        icon: <IconComp style={{ fontSize: 20, color: provisionOpt.color }} />, 
        label: provisionOpt.label
      };
    } else {
      // Mostra icona undefined in grigio con HelpOutlineIcon
      provisionIconObj = {
        icon: <HelpOutlineIcon style={{ fontSize: 20, color: '#bbb' }} />, // fallback icona
        label: row.service_provision ? row.service_provision : 'Undefined'
      };
    }
    return (
      <div style={{ display: 'flex', gap: 0, alignItems: 'center', minWidth: 150 }}>
        <Tooltip title="Edit">
          <IconButton size="small" onClick={() => onOpenEditDialog && onOpenEditDialog(row)} style={{ padding: 4 }}>
            <EditIcon style={{ color: '#111', fontSize: 20 }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton size="small" onClick={() => this.deleteService(row.id)} style={{ padding: 4 }}>
            <DeleteIcon style={{ color: 'darkred', fontSize: 20 }} />
          </IconButton>
        </Tooltip>                
        <Tooltip title={provisionIconObj.label}>
          <span style={{ display: 'inline-flex', alignItems: 'center', marginRight: 4 }}>{provisionIconObj.icon}</span>
        </Tooltip>
        <Tooltip title={iconDisabled ? 'No Description or Solution' : 'View Description/Solution'}>
          <span>
            <IconButton size="small" disabled={iconDisabled} onClick={() => !iconDisabled && this.setState({ dialogOpen: true })} style={{ padding: 4 }}>
              <DescriptionIcon style={{ color: iconColor, fontSize: 20 }} />
            </IconButton>
          </span>
        </Tooltip>
        
        {/* Dialog per visualizzare Description e Solution */}
        <Dialog open={dialogOpen} onClose={() => this.setState({ dialogOpen: false })} maxWidth="md" fullWidth>
          <DialogTitle>Service Activity {row.id}</DialogTitle>
          <DialogContent>
            <div style={{ marginBottom: 16, fontWeight: 'bold', color: '#1976d2' }}>Description</div>
            <div style={{ minHeight: 40, marginBottom: 24 }}
              dangerouslySetInnerHTML={{ __html: hasDesc ? row.service_desc : '<span style="color:#bbb">(none)</span>' }} />
            <div style={{ marginBottom: 16, fontWeight: 'bold', color: '#43a047' }}>Solution</div>
            <div style={{ minHeight: 40 }}
              dangerouslySetInnerHTML={{ __html: hasSolution ? row.service_solution : '<span style="color:#bbb">(none)</span>' }} />
          </DialogContent>
        </Dialog>
      </div>
    );
  }
};

class ActionsTypeProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataToEdit: null,
    };
  }
  
  render() {
    const { for: forColumns, ...rest } = this.props;
    return (
      <>
        <DataTypeProvider
          formatterComponent={props => <ActionsFormatter 
              row={props.row} 
              onOpenEditDialog={row => this.setState({ dataToEdit: row })}              
              onItemsChange={this.props.onItemsChange}
            />}
          for={forColumns}
          {...rest} />
          
        <EditServiceActivityDialog
          dataId={this.state.dataToEdit ? this.state.dataToEdit.id : null}
          onClose={() => this.setState({ dataToEdit: null })}
          onItemsChange={this.props.onItemsChange} />
      </>
    );
  }
}

export default ActionsTypeProvider;
